if (!customElements.get('uuin-product-info')) {
  customElements.define('uuin-product-info', class extends HTMLElement {
    connectedCallback() {
      this.productRoot = this.closest('product-info');
      this.organizeDescription();
      this.syncSizeLink = () => {
        const target = this.querySelector('[data-size-guide]');
        if (!target || !this.productRoot) return;
        this.productRoot.querySelectorAll('variant-selects .product-form__input').forEach(group => {
          const label = group.querySelector('legend, label.form__label');
          if (!label || !/size|尺寸/i.test(label.textContent) || group.querySelector('.uuin-size-guide-link')) return;
          const sourceBody = target.querySelector('.uuin-info-body');
          if (!sourceBody) return;
          const link = document.createElement('button');
          link.className = 'uuin-size-guide-link';
          link.type = 'button';
          link.setAttribute('aria-expanded', 'false');
          link.textContent = 'SIZE GUIDE';
          const panel = document.createElement('div');
          panel.className = 'uuin-size-guide-inline';
          panel.hidden = true;
          panel.id = target.id + '-inline';
          panel.append(sourceBody.cloneNode(true));
          link.setAttribute('aria-controls', panel.id);
          const destination = group.classList.contains('uuin-size-picker') ? group : label;
          destination.append(link, panel);
        });
      };
      this.onSizeClick = event => {
        const link = event.target.closest('.uuin-size-guide-link');
        if (!link) return;
        event.preventDefault();
        const panel = link.parentElement.querySelector('.uuin-size-guide-inline');
        if (!panel) return;
        const willOpen = panel.hidden;
        panel.hidden = !willOpen;
        link.setAttribute('aria-expanded', String(willOpen));
      };
      this.syncLineInquiry = () => {
        if (!this.productRoot) return;
        const inquiry = this.productRoot.querySelector('[data-line-inquiry]');
        const link = inquiry?.querySelector('.uuin-line-inquiry__button');
        if (!inquiry || !link) return;
        const title = inquiry.dataset.productTitle || document.querySelector('h1')?.textContent.trim() || '';
        const size = this.productRoot.querySelector('.uuin-size-picker select')?.value || '';
        const sku = this.productRoot.querySelector('.uuin-visible-sku')?.textContent.trim() || '';
        const productUrl = location.origin + location.pathname + location.search;
        const message = [
          `想詢問「${title}」`,
          size ? `尺寸：${size}` : '',
          sku,
          productUrl,
        ].filter(Boolean).join('\n');
        const profileUrl = 'https://line.me/R/ti/p/%40303dmwlv';
        const messageUrl = `https://line.me/R/oaMessage/%40303dmwlv/?${encodeURIComponent(message)}`;
        link.dataset.mobileHref = messageUrl;
        link.dataset.desktopHref = profileUrl;
        link.href = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? messageUrl : profileUrl;
      };
      this.syncSizeLink();
      this.syncLineInquiry();
      this.productRoot?.addEventListener('click', this.onSizeClick);
      this.observer = new MutationObserver(() => {
        this.syncSizeLink();
        this.syncLineInquiry();
      });
      if (this.productRoot) this.observer.observe(this.productRoot, {childList: true, subtree: true});
    }
    disconnectedCallback() {
      this.productRoot?.removeEventListener('click', this.onSizeClick);
      this.observer?.disconnect();
    }
    organizeDescription() {
      const source = this.querySelector('[data-description-source]');
      const care = this.querySelector('[data-extra-care]');
      if (!source || !care || source.querySelector('img, table, video, iframe, a, ul, ol') || source.dataset.organized) return;
      const paragraphs = [...source.children];
      if (!paragraphs.length || paragraphs.some(el => el.tagName !== 'P')) return;
      const description = [];
      const materials = [];
      paragraphs.forEach(paragraph => {
        const clone = paragraph.cloneNode(true);
        clone.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode('\n')));
        clone.textContent.split(/\n+/).map(text => text.trim()).filter(Boolean).forEach(text => {
          (/^(?:表布|裡布|裏布|面料|成分|材質)\s*[:：]|^※/.test(text) ? materials : description).push(text);
        });
      });
      if (!description.length) return;
      const readableParagraphs = [];
      description.forEach((text, index) => {
        if (index === 0 && text.length <= 40) {
          readableParagraphs.push({text, lead: true});
          return;
        }
        const sentences = text.match(/[^。！？]+[。！？]?/gu) || [text];
        let paragraph = '';
        sentences.forEach(sentence => {
          if (paragraph && paragraph.length + sentence.length > 110) {
            readableParagraphs.push({text: paragraph});
            paragraph = '';
          }
          paragraph += sentence;
        });
        if (paragraph) readableParagraphs.push({text: paragraph});
      });
      source.replaceChildren(...readableParagraphs.map(({text, lead}) => {
        const p = document.createElement('p');
        p.textContent = text;
        if (lead) p.className = 'uuin-description-lead';
        return p;
      }));
      materials.forEach(text => {
        if (/^(?:表布|裡布|裏布|面料|成分|材質)\s*[:：]/.test(text)) {
          const value = text.replace(/^[^:：]+[:：]/, '').replace(/\s+/g, '');
          const specs = this.querySelector('.product-specs__list')?.textContent.replace(/\s+/g, '') || '';
          if (value && specs.includes(value)) return;
        }
        const p = document.createElement('p');
        p.textContent = text;
        care.append(p);
      });
      source.dataset.organized = 'true';
    }
  });
}
